import React, { useEffect, useState } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import Tabs from '../../components/tabs';
import CustomButton from '../../components/customButton';

const ManageReportModal = ({ report, sections, isOpen, onCancel, toggle }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    setSelectedTab(0);
  }, [isOpen, report?.id]);

  const getPagesFromSteps = steps => {
    return steps.map(step => {
      const newStep = { ...step, name: step.header };
      newStep.content = (
        <div>
          <h2 className="section-header">
            Editing {newStep.header.toLowerCase()} on {report.displayName}
          </h2>{' '}
          {newStep.body}
        </div>
      );
      delete newStep.header;
      return newStep;
    });
  };
  // Build pages and ensure there's always at least one tab
  const pages = getPagesFromSteps(sections || []);
  const pagesTabs = pages && pages.length ? pages : [{ name: 'Details', content: <></> }];

  // Map of save functions registered by each ReportInfo instance (keyed by tab index)
  const saveFunctionsRef = React.useRef({});

  const registerSaveForIndex = index => registrationFactory => {
    const notify = () => {};

    let reg = registrationFactory;
    if (typeof registrationFactory === 'function') {
      reg = registrationFactory(notify) || {};
    }

    saveFunctionsRef.current[index] = reg;

    return () => {
      delete saveFunctionsRef.current[index];
    };
  };

  // If selectedTab is out of range (e.g. sections changed), clamp it to 0
  React.useEffect(() => {
    if (selectedTab >= pagesTabs.length) {
      setSelectedTab(0);
    }
  }, [selectedTab, pagesTabs.length]);

  return (
    <Modal size="xl" isOpen={isOpen} fade={false} centered id="manage-devices-modal">
      <ModalBody>
        <Tabs
          classes="manage-report-tabs"
          onTabsChange={setSelectedTab}
          selectedTab={selectedTab}
          pages={{
            tabs: pagesTabs.map((p, i) => {
              const original = p.content;
              if (!React.isValidElement(original)) return p;
              const children = React.Children.map(original.props.children, child => {
                if (React.isValidElement(child) && typeof child.type !== 'string') {
                  return React.cloneElement(child, { registerSave: registerSaveForIndex(i) });
                }
                return child;
              });
              const newContent = React.cloneElement(original, {}, children);
              return {
                ...p,
                content: newContent
              };
            })
          }}
        />
      </ModalBody>
      <ModalFooter>
        <CustomButton
          handleClick={() => {
            const cb = onCancel ? onCancel : toggle;
            cb();
          }}
          classes="btn-secondary"
          title="Cancel"
          disabled={false}
        />
        {selectedTab === 0 && (
          <CustomButton
            handleClick={() => {
              const reg = saveFunctionsRef.current[selectedTab];
              if (reg) {
                if (typeof reg === 'function') {
                  reg();
                } else if (typeof reg.save === 'function') {
                  reg.save();
                } else {
                  toggle();
                }
              }
              toggle();
            }}
            classes="btn-primary"
            title="Confirm"
            disabled={false}
          />
        )}
      </ModalFooter>
    </Modal>
  );
};

export default ManageReportModal;
